import { Capacitor } from '@capacitor/core';
import { Dialog } from '@capacitor/dialog';

export const confirmationModal = (text: string, callBack: () => void) => {
  if (Capacitor.isNativePlatform()) {
    Dialog.confirm({ title: 'Conferma', message: text }).then((result) => {
      if (result.value) {
        callBack();
      }
    });
  } else {
    if (window.confirm(text)) {
      callBack();
    }
  }
};

export const alertModal = (text: string) => {
  if (Capacitor.isNativePlatform()) {
    Dialog.alert({ title: 'Attenzione', message: text });
  } else {
    window.alert(text);
  }
};
